<template>
  <div class="min-h-screen bg-white py-8">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="text-center mb-12">
        <h1 class="text-4xl font-bold text-primary mb-2">
          {{ $t("terms.title") }}
        </h1>
        <p class="text-gray-500">
          {{ $t("terms.last_updated") }}: {{ localizedDate }}
        </p>
      </div>

      <div class="leading-relaxed space-y-10">
        <component :is="currentContent" />
      </div>

      <!-- <div class="text-center mt-16 text-sm text-gray-400">
        <p>{{ $t("terms.acknowledgment") }}</p>
      </div> -->
    </div>
  </div>
</template>

<script setup lang="ts">
const { t, locale } = useI18n();

const currentContent = computed(() => {
  if (locale.value === "hy") return resolveComponent("LegalTermsHy");
  if (locale.value === "ru") return resolveComponent("LegalTermsRu");
  return resolveComponent("LegalTermsEn");
});

const { localizedDate } = useLocalizedDate();

useSeoMeta({
  title: () => t("terms.title"),
  ogTitle: () => t("terms.title"),
  description: () => t("terms.seo_description"),
  ogDescription: () => t("terms.seo_description"),
  ogImage: "https://medium.am/logo.png",
  twitterImage: "https://medium.am/logo.png",
  ogType: "website",
  twitterCard: "summary",
});
</script>
